/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable camelcase */
import '@jutro/legacy/address';
import {
    ModalNextEmitter,
    TooltipIcon, 
    useModal,
} from '@jutro/components';
import { Button } from '@jutro/legacy/components';
import { AppFloorPlan } from '@jutro/legacy/floorplan';
import '@jutro/legacy/dataview';
import { useBreakpoint } from '@jutro/layout';
import { useTranslator } from '@jutro/locale';
import { routeConfirmationModal, DropdownMenuLink, Link } from '@jutro/router';
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { 
    withAuthenticationProvider, 
    privateRouteWithAuthContext 
} from 'ent-capability-digital-auth-react';
import { AccurateBreakpointPropagation } from '@xengage/gw-jutro-adapters-react';
import { AgencyAdminService } from 'twia-capability-agencyadmin';
import vmTranslator, {
    messages as commonMessages,
} from '@xengage/gw-platform-translations';
import { filterCapabilityRoutes } from '@xengage/gw-portals-config-js';
import { DependencyProvider } from '@xengage/gw-portals-dependency-react';
import { ErrorBoundary } from '@xengage/gw-portals-error-react';
import { withMaintenancePage } from '@xengage/gw-portals-maintenance-react';
import { ViewModelServiceFactory } from '@xengage/gw-portals-viewmodel-js';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import htmlParser from 'html-react-parser';
import appConfig from 'app-config';
import {
    AddressLookupComponentMap,
    AddressLookupComponents,
} from 'gw-capability-address-react';
import { ClaimDetails } from 'gw-capability-claim-react';
import { PolicyDocumentError } from 'gw-capability-document-react';
import FaqPage from 'gw-capability-faq-react';
import FNOLBOPWizard from 'gw-capability-fnol-bop-react';
import FNOLCAWizard from 'gw-capability-fnol-ca-react';
import BaseFNOLWizard, {
    ClaimsConfirmationPage,
} from 'twia-capability-fnol-common-react';
import FNOLCPWizard from 'twia-capability-fnol-cp-react';
import FNOLGeneralWizard from 'gw-capability-fnol-gl-react';
import FNOLHOWizard from 'twia-capability-fnol-ho-react';
import FNOLHOTFPAWizard from 'tfpa-capability-fnol-ho-react';
import FNOLPAWizard from 'gw-capability-fnol-pa-react';
import FNOLWCWizard from 'gw-capability-fnol-wc-react';
import {
    JobService,
    SearchService,
    SubmissionService,
    UserService,
} from 'gw-capability-gateway';
import { GatewayBillingService } from 'gw-capability-gateway-billing';
import { ENTGatewayClaimService } from 'ent-capability-gateway-claim';
import { ClaimsLanding } from 'gw-capability-gateway-claim-react';
import { ENTGatewayClaimDocumentService } from 'ent-capability-gateway-claimdocument';
import { CommissionLanding } from 'gw-capability-gateway-commission-react';
import { TWIAResourcesService } from 'twia-capability-constants';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import { GatewayFNOLService } from 'twia-capability-gateway-fnol';
import { AccountService } from 'gw-capability-gateway-policy';
import { GatewayEndorsementService } from 'gw-capability-gateway-policychange';
import { GatewayAvailabilityService } from 'gw-capability-gateway-policycommon';
import { GatewayRenewalService } from 'gw-capability-gateway-policyrenewal';
import {
    CustomQuoteService,
    LoadSaveService,
} from 'gw-capability-gateway-quoteandbind';
import { CustomQuoteService as TwiaCustomQuoteService } from 'twia-capability-quoteandbind-residential';
import PELandingPage, {
    AccountBillingAndPayment,
    AccountDetails,
    Accounts,
    Activities,
    Analytics,
    Cancellation,
    ContactUnderwriter,
    Endorsement,
    MakePayment,
    NewQuotePage,
    PaymentConfirmation,
    Policies,
    PolicyDetails,
    producerEngageAdditionalComponents,
    producerEngageComponentMap,
    QuoteDetails,
    Renewal,
    SearchResults,
    Administration,
    AddUser,
    EditUser, // DE15292 imported for routing
    NewQuoteAccountSearch
} from 'gw-capability-gateway-react';
import { GatewaySpreadsheetService } from 'gw-capability-gateway-spreadsheet';
import {
    policyJobComponentMap,
    policyJobComponents,
} from 'gw-capability-policyjob-react';
import {
    SuccessPage,
    TWIASuccessPage,
    TFPASuccessPage,
    entCommonComponentMap,
    entCommonComponents
} from 'ent-capability-quoteandbind-common-react';
import { ProducerInfoService } from 'gw-capability-profileinfo';
import {
    VehicleInfoLookupComponentMap,
    VehicleInfoLookupComponents,
} from 'gw-capability-vehicleinfo-react';
import {
    ImageComponent,
    KnockOutPage,
    platformComponentMap,
    platformComponents,
} from 'gw-components-platform-react';
import {
    entPlatformComponentMap,
    entPlatformComponents,
} from 'ent-components-platform-react';
import { SelectProducerContextProvider } from 'gw-gateway-common-react';
import { checkMaintenanceMode }  from 'gw-maintenance-js';
import { getConfigValue } from '@jutro/config';
import { ContactAgentPage, Preferences } from 'gw-pages-platform-react';
import { PolicyTransactionPage } from 'gw-policytransaction-react';
import { WizardPageTemplateWithTitle } from 'gw-portals-wizard-components-ui';
import _ from 'lodash';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Redirect, Router, useHistory } from 'react-router-dom';
import IsEastOfHwy146Util from 'twia-capability-quoteandbind-residential-react/util/IsEastOfHwy146Util';
// USUS26354 TWIA Residential Side Menu
import { TWIAResidentialWizard } from 'twia-capability-quoteandbind-residential-react';
import { TWIACommercialWizard } from 'twia-capability-quoteandbind-cp-react';
import { TWIAResidentialRenewalWizard } from 'twia-capability-renewal-ho-react';
import { TWIACommercialRenewalWizard } from 'twia-capability-renewal-cp-react';
import { TWIACommercialChangeWizard } from 'twia-capability-policychange-cp-react';
import { TWIAWizardTemplate } from 'twia-portals-wizard-components-ui';
// TFPA Residential Side Menu - Wizard and Template
import { TFPAResidentialWizard } from 'tfpa-capability-quoteandbind-residential-react';
import { TFPAWizardTemplate } from 'tfpa-portals-wizard-components-ui';
import { EndorsementConfirmation } from "twia-capability-policychange-common-react";
import { RenewalConfirmation } from 'twia-capability-renewal-common-react';
import { PolicyRenewalSummary } from 'tfpa-capability-renewal-common-react';
import './App.scss';
import { 
    TWIABatchesComponentMap,
    TWIABatchesComponent,
    TWIABatchesLanding,
    AddTransferRequest,
    TransferRequestDetails,
    TwiaCommissionLanding
} from 'ent-capability-policyportfolio-react';
import StandardAddressValidationUtil from 'twia-capability-quoteandbind-residential-react/util/StandardAddressValidationUtil';
import { AgencyActivationService } from 'ent-capability-agencyactivation';
import DwellingAdditionalInterestUtil from 'tfpa-capability-quoteandbind-residential-react/util/DwellingAdditionalInterestUtil';
import { TWIAResidentialChangeWizard } from 'twia-capability-policychange-ho-react';
import { TFPAChangeResidentialWizard } from 'tfpa-capability-policychange-TFPAResidential-react';
import { Autologout } from 'ent-capability-autologout-react';
import { LogoutPage } from 'ent-capability-logout-react';
import appRoutes from './App.routes.metadata.json5';
import messages from './App.messages';
import { 
    AgentRegistrationWizard,  
    AgentRegistrationWizardTemplate, 
    ActivationPage, 
    UserActivationPage 
// eslint-disable-next-line import/no-relative-packages
} from '../../../common/capabilities-react/ent-capability-agentregistration-react';

const { capabilitiesConfig, env, gatewayAnalytics, applicationDetails } =    appConfig;

// US26535 redirect to login error page in some cases
const loginErrorRedirectUrl = getConfigValue('LOGIN_ERROR_REDIRECT_URL', appConfig.enterpriseLoginErrorURL);

const componentMap = {
    // this has to keep "privateRouteWithAuthContext" because it doesn't use the 
    // "useAuthentication" hook (old style class format of react). So it get nulls
    // on the authHeader without this context
    landingpage: privateRouteWithAuthContext(PELandingPage), 
    accounts: Accounts,
    policies: Policies,
    activities: Activities,
    analytics: Analytics,
    accountdetails: AccountDetails,
    policydetails: privateRouteWithAuthContext(PolicyDetails),
    newquoteaccountsearch: NewQuoteAccountSearch,
    newquotepage: NewQuotePage,
    searchresults: SearchResults,
    quotedetails: privateRouteWithAuthContext(QuoteDetails),
    renewal: privateRouteWithAuthContext(Renewal), 
    endorsement: privateRouteWithAuthContext(Endorsement), // DE18061
    cancellation: Cancellation,
    accountbillingandpayment: AccountBillingAndPayment,
    makepayment: MakePayment,
    contactunderwriter: ContactUnderwriter,
    paymentconfirmation: PaymentConfirmation,
    basefnolwizard: BaseFNOLWizard,
    claimsconfirmationpage: ClaimsConfirmationPage,
    contactagentpage: ContactAgentPage,
    preferences: Preferences,
    fnolhowizard: FNOLHOWizard,
    fnolpawizard: FNOLPAWizard,
    fnolcawizard: FNOLCAWizard,
    fnolcpwizard: FNOLCPWizard,
    fnolwcwizard: FNOLWCWizard,
    fnolbopwizard: FNOLBOPWizard,
    fnolgeneralwizard: FNOLGeneralWizard,
    faqpage: FaqPage,
    knockoutpage: KnockOutPage,
    claimdetails: ClaimDetails,
    claimslanding: ClaimsLanding,
    commissionlanding: CommissionLanding,
    policydocumenterror: PolicyDocumentError,
    policytransactionpage: PolicyTransactionPage,
    agentregistrationwizard: AgentRegistrationWizard,
    activation: ActivationPage,
    useractivation: UserActivationPage,
    administration: Administration,
    tfparesidentialwizard: TFPAResidentialWizard,
    twiaresidentialwizard: TWIAResidentialWizard,
    twiacommercialwizard: TWIACommercialWizard,
    twiaresidentialrenewalwizard: TWIAResidentialRenewalWizard,
    addUser: AddUser,
    editUser: EditUser,
    successPage: SuccessPage,
    TWIASuccessPage,
    TFPASuccessPage,
    fnolhotfpawizard: FNOLHOTFPAWizard,
    twiacommercialrenewalwizard: TWIACommercialRenewalWizard,
    renewalConfirmationPage: RenewalConfirmation,
    endorsementConfirmationPage: EndorsementConfirmation,
    policyRenewalSummaryPage: PolicyRenewalSummary,
    twiacommercialpolicychangewizard: TWIACommercialChangeWizard,
    twiaresidentialpolicychangewizard: TWIAResidentialChangeWizard,
    tfpachangeresidentialwizard: TFPAChangeResidentialWizard,
    TWIABatchesLanding,
    AddTransferRequest,
    TransferRequestDetails,
    TwiaCommissionLanding,
    logoutpage: LogoutPage,
};

setComponentMapOverrides(
    {
        ...platformComponentMap,
        ...entPlatformComponentMap,
        ...AddressLookupComponentMap,
        ...VehicleInfoLookupComponentMap,
        ...producerEngageComponentMap,
        ...policyJobComponentMap,
        ...entCommonComponentMap,
        ...TWIABatchesComponentMap,
        WizardPageTemplateWithTitle: {
            component: 'WizardPageTemplateWithTitle',
        },
        AgentRegistrationWizardTemplate: {
            component: 'AgentRegistrationWizardTemplate',
        },
        TWIAWizardTemplate: {
            component: 'TWIAWizardTemplate',
        },
        TFPAWizardTemplate: {
            component: 'TFPAWizardTemplate',
        },
        // replace the native IMG component with a proxied version
        img: { component: 'img' },
    },
    {
        ...platformComponents,
        ...entPlatformComponents,
        ...AddressLookupComponents,
        ...VehicleInfoLookupComponents,
        ...producerEngageAdditionalComponents,
        ...policyJobComponents,
        ...entCommonComponents,
        WizardPageTemplateWithTitle,
        AgentRegistrationWizardTemplate,
        TWIAWizardTemplate,
        TFPAWizardTemplate,
        img: ImageComponent,
        ...TWIABatchesComponent,
    }
);

const defaultRoutes = filterCapabilityRoutes(
    capabilitiesConfig,
    appRoutes.routes
);


// US26535 redirect to TWIA login error page for certain codes
const redirectError = e => {
    const errorCode = _.get(e, 'data.appErrorCode');
    const isRedirectError = errorCode == 10076;

    if (isRedirectError && loginErrorRedirectUrl) {
        window.location.href = loginErrorRedirectUrl;
    }

    return isRedirectError;
};

const getUserAuthData = authData => UserService.getGatewayCurrentUser(authData.authHeader)
    .catch(e => {
        const errorCode = _.get(e, 'data.appErrorCode');

        if (!redirectError(e) && authData) {
            authData.logout();
        } 
    });

const modalEmitter = new ModalNextEmitter();

function App() {
    const { showAlert } = useModal();
    const history = useHistory();
    const auth = useAuthentication();
    const translator = useTranslator();
    const [viewModelService, updateViewModelService] = useState(undefined);
    const [permissionCheck, updatePermissionCheck] = useState(false);
    const [activateAgency, updateActivateAgency] = useState(true);
    const [routes, updateRoutes] = useState(defaultRoutes);
    const [banner,setBanner] = useState('')
    const { breakpoint } = useBreakpoint({});
    let lastOpenWrapper = null;

    const agentRegistration = useMemo(() => {
        const pathName = _.get(window, 'location.pathname');

        // DE17848 support button suppression and logos for activation
        return pathName && (pathName.includes('/new-agent') || 
                            pathName.includes('/activationlink') || 
                            pathName.includes('/fwUserSelfActivation'));
    });

    const getLogoSrc = useCallback(() => {

        let logoName = '';

        if (auth && auth.authUserData && !agentRegistration) {
            const {authUserData: { associationName_TWIA } } = auth;

            if (associationName_TWIA === 'twia') {
                if (breakpoint === 'phone' || breakpoint === 'phoneWide' || breakpoint === 'tablet') {
                    logoName = applicationDetails.applicationLogoTWIAMobile;
                } else {
                    logoName = applicationDetails.applicationLogoTWIA;
                }                
            }
            else if (associationName_TWIA === 'tfpa') {
                if (breakpoint === 'phone' || breakpoint === 'phoneWide' || breakpoint === 'tablet') {
                    logoName = applicationDetails.applicationLogoTFPAMobile;
                } else {
                    logoName = applicationDetails.applicationLogoTFPA;
                } 
                
            }
        }

        const searchParams = new URLSearchParams(window.location.search);

        if (agentRegistration && searchParams.get('company') === '1001_00001') {
            logoName = applicationDetails.applicationLogoTFPA;
        }

        if (agentRegistration && searchParams.get('company') === '2001_00001') {
            logoName = applicationDetails.applicationLogoTWIA;
        }

        const prefix = _.get(env, 'DEPLOYMENT_PATH', '').replace(/\/$/, '');

        return `${prefix}/${logoName}`;
    }, [auth, breakpoint, agentRegistration]);

    useEffect(() => {
        if (activateAgency && auth && auth.authHeader) {
            const activate = async () => {
                try {
                    await AgencyActivationService.activateAgency(auth.authHeader);

                    if (auth && auth.authUserData && !agentRegistration) {
                        const { authUserData: { associationName_TWIA }, authHeader } = auth;
                        const association = associationName_TWIA === 'twia' ? 'twiaagent' : 'tfpaagent'
                        const result = await TWIAResourcesService.getPortalBannerTWIA(association, authHeader);

                        setBanner(result)
                    }
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error(`unable to activate agency ${e}`);
                }

                updateActivateAgency(false);
            }

            activate();

            // DE17583 enable automatic logout
            const cfg = appConfig.autoLogout;
            const idleTimeMinutes = getConfigValue('IDLE_TIME_MINUTES', cfg.idleMinutes);
            const logoutTimeMinutes = getConfigValue('LOGOUT_TIME_MINUTES', cfg.logoutMinutes);

            Autologout.enableAutoLogout(showAlert, auth.logout, idleTimeMinutes, logoutTimeMinutes);
        }
    }, [activateAgency, agentRegistration, auth, showAlert]);

    useEffect(() => {
        const translatorFn = vmTranslator(translator);

        import(
            /* webpackChunkName: "product-metadata" */
            'product-metadata'
        ).then(productMetadata => {
            if (!productMetadata || _.isEmpty(productMetadata.default)) {
                throw new Error(translator(messages.errorMetadataMessage));
            }

            const { default: result } = productMetadata;

            updateViewModelService(
                ViewModelServiceFactory.getViewModelService(
                    result,
                    translatorFn
                )
            );

            // US26344
            StandardAddressValidationUtil.setProductMetadata(result);
            DwellingAdditionalInterestUtil.setInsuranceSuiteMetadata(result); // DE16373

            if (_.get(auth, 'authHeader')) {
                // US26344
                TwiaCustomQuoteService.postalCodesEastOfHwy146(auth.authHeader)
                .then((resp) => {
                    IsEastOfHwy146Util.setPostalCodesEastOfHwy146(resp);
                }); 
            }
        });
    }, [auth, translator]);

    /**
     * DE18354: UAT - Mouse scroll wheel increases/decreases values in integer fields.
     * This is a workaround due to the fact that the latest GW component 'NumberInput'
     * cannot be used in metadata.json.
     * When we move away from metadata.json we can revisit using 'NumberInput'
     * 'noScrollEnt' is basically a marker we put in the classname in order to ONLY 
     * disable scrolling on those 'marked' components
     */
    useEffect(() => {
        document.addEventListener("wheel", (e) => {
            if (e.target.tagName?.toUpperCase() == 'INPUT' && e.target.className.includes('noScrollEnt')) {
                e.preventDefault(); // Prevents the default scrolling behavior
            }
        }, { passive: false }); // Set passive to false to allow preventDefault()
        
        /**
         * DE17982: CloudPortals_SIT: PE TWIA - Error message for wrong date format is not displayed for Most Recent Tie Down Date on a MH new submission
         * This is a workaround because the Jutro date validation error is not displayed,
         * when the user shifts focus using the calendar icon without tabbing.
         * After Jutro provides a fix for this issue, we can revisit it
         */
        document.addEventListener("click", (e) => {
            // Is calendar open anywhere?
            const isCalendarOpen = !!document.querySelector(".react-datepicker");
            // Check if clicking inside any wrapper
            const clickedWrapper = e.target.closest('.react-datepicker-wrapper');
            if (isCalendarOpen) {
                // If calendar open, remember the wrapper it is open for
                if (clickedWrapper) {
                    lastOpenWrapper = clickedWrapper;
                }
            } else {
                // Calendar closed: use the last known open wrapper
                if (lastOpenWrapper) {
                    const inputElement = lastOpenWrapper.querySelector('input');

                    if (inputElement) {
                        inputElement.focus();
                        inputElement.blur();
                    }
                    lastOpenWrapper = null; // reset after handling
                }
            }
        });

    }, []);

    const handleError = useCallback(
        (error = {}) => {
            const state = {
                pathname: '/',
                state: error,
            };

            if (redirectError(error)) {
                // US26535 no alert needed for redirect
                return Promise.resolve();
            } 
                // eslint-disable-next-line padding-line-between-statements
                return showAlert({
                    title: messages.error,
                    message: messages.errorMessage,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok,
                }).then(() => <Redirect to={state} />, _.noop);
            
        },
        [showAlert]
    );

    const avatarLinks = useMemo(
        () =>{ 
            // US29415: PE/CE -Enable optional MFA (multi-factor authentication) for Agents and policyholders
            const accountSecurityBaseUrl = getConfigValue('ACCOUNT_SECURITY_URL', appConfig.accountSecurityUrl);
            const jutroAuthRedirectBase = getConfigValue('JUTRO_AUTH_REDIRECT_BASE', appConfig.authentication.servers.okta.JUTRO_AUTH_REDIRECT_BASE);
            const accountSecurityUrl = accountSecurityBaseUrl + jutroAuthRedirectBase;

            return [
                <DropdownMenuLink key="userProfile" to="/userProfile">
                    {translator(messages.userProfile)}
                </DropdownMenuLink>,
                <DropdownMenuLink key="accountSecurity" href={accountSecurityUrl}>
                    {translator(messages.addAccountSecurity)}
                </DropdownMenuLink>,
                <DropdownMenuLink key="logout" onClick={() => auth.logout()}>
                    {translator(messages.logOut)}
                </DropdownMenuLink>,
            ];
        },
        [translator, auth]
    );
    
    const agencyAdminRoles = {
        'OrganizationAdminRoleCode': 'POA-000',
        'CommunityAdminRoleCode': 'PCA-000',
        'EFTEnabledRoleCode': 'PEFTE-000'
    };
    
    const roles = [agencyAdminRoles.OrganizationAdminRoleCode, agencyAdminRoles.CommunityAdminRoleCode];

    const checkAdminiPermission = useCallback(() => {
    
        if (_.isEmpty(_.get(auth, 'authHeader')) || permissionCheck || agentRegistration) {
            return;
        }

        updatePermissionCheck(true);
        
        AgencyAdminService.userHasEitherRolesByCode(roles, auth.authHeader).then(
            (hasPermission) => {
                const routesToBeUpdated = ['/administration'];
                let updatedRoutes = 0;

                for (const route of routes) {
                    if (routesToBeUpdated.includes(route.path)) {
                        updatedRoutes += 1;
                        route.showOnNavBar = hasPermission;
                    }

                    if (routesToBeUpdated.length === updatedRoutes) {
                        break;
                    }
                }

                updateRoutes([...routes]);
            }
        );
        
    }, [auth, routes])

    const checkViewBulkProducerChangePermission = useCallback(() => {
        const bulkProducerChangeDTO = {
            permission: 'viewbulkproducerchange_ext',
        };

        if (_.isEmpty(_.get(auth, 'authHeader')) || permissionCheck || agentRegistration) {
            return;
        }

        updatePermissionCheck(true);

        const bulkProducerChangePermission = UserService.hasUserSystemPermission(
            bulkProducerChangeDTO,
            auth.authHeader
        );

        Promise.all([bulkProducerChangePermission]).then(
            ([hasBulkProducer]) => {
                const routesToBeUpdated = ['/batches'];
                let updatedRoutes = 0;

                for (const route of routes) {
                    if (routesToBeUpdated.includes(route.path)) {
                        updatedRoutes += 1;
                        route.showOnNavBar =
                            route.path === '/batches'
                                ? hasBulkProducer
                                : null;
                    }

                    if (routesToBeUpdated.length === updatedRoutes) {
                        break;
                    }
                }

                updateRoutes([...routes]);
            }
        );
    }, [auth, permissionCheck, routes]);

    const checkViewCommissionsAnalyticsPermission = useCallback(() => {
        const commissionsDTO = {
            permission: 'viewcommissions',
        };

        const reportsDTO = {
            permission: 'gpaviewreports',
        };

        if (_.isEmpty(_.get(auth, 'authHeader')) || permissionCheck || agentRegistration) {
            return;
        }

        updatePermissionCheck(true);

        const commissionPermission = UserService.hasUserSystemPermission(
            commissionsDTO,
            auth.authHeader
        );

        const analyticsPermission = UserService.hasUserSystemPermission(
            reportsDTO,
            auth.authHeader
        );

        Promise.all([commissionPermission, analyticsPermission]).then(
            ([hasCommission, hasAnalytics]) => {
                const routesToBeUpdated = ['/commission', '/analytics'];
                let updatedRoutes = 0;

                for (const route of routes) {
                    if (routesToBeUpdated.includes(route.path)) {
                        updatedRoutes += 1;
                        route.showOnNavBar =
                            route.path === '/commission'
                                ? hasCommission
                                : gatewayAnalytics && hasAnalytics;
                    }

                    if (routesToBeUpdated.length === updatedRoutes) {
                        break;
                    }
                }

                updateRoutes([...routes]);
            }
        );
    }, [auth, permissionCheck, routes]);

    const onSearchValueChange = useCallback(
        selectedValue => {
            const searchText = _.get(selectedValue, 'id', '');

            if (!_.isEmpty(searchText)) {
                let redirectPath = `/search/${searchText}`;

                if (_.get(selectedValue, 'type', '') === 'account') {
                    redirectPath = `/accounts/${searchText}/summary`;
                }

                if (_.get(selectedValue, 'type', '') === 'policy') {
                    redirectPath = `/policies/${searchText}/summary`;
                }

                history.push(redirectPath);
            }
        },
        [history]
    );

    const formatSearchValues = useCallback((displayName, id, type) => {
        const availableObject = {
            displayName,
            id,
            type,
        };

        return availableObject;
    }, []);

    const handleLoadValues = useCallback(
        async searchParam => {
            const searchObj = {
                previousSearchParam: '',
                searchParam,

                 // 2024-10-04 - Debra Frum - US26423 - PE - Search Accounts, Policies, Contacts - Solr Search
                 active: false,
                 hasMoreResults: false,
                 sortField: ''
            };
            const displayName = translator(messages.viewAll, {
                Number: searchParam,
            });
            const viewAll = formatSearchValues(displayName, searchParam, '');

            // 2024-10-04 - Debra Frum - US26423 - PE - Search Accounts, Policies, Contacts - Solr Search
            const queryOptions = {
                pageNumber_TWIA: 0,
                orderBy: 'CreateTime',
                // orderByAscending: false
                orderByDescending: true
            };

            // 2024-10-04 - Debra Frum - US26423 - PE - Search Accounts, Policies, Contacts - Solr Search
            // const searchResults = await SearchService.search(searchObj, auth.authHeader);
            const searchResults = await SearchService.search(
                searchObj, 
                queryOptions,
                auth.authHeader
            );

            const availableValues = [viewAll];

            // 2024-10-09 - Debra Frum - US26423 - PE - Search Accounts, Policies, Contacts - Solr Search
            //   Remove creating drop-down option list of search results that user can select for subsequent 
            //   searches since their format isn't valid Solr search criteria
            // if (!_.isEmpty(searchResults)) {
            //     const { accounts, policies } = searchResults;

            //     if (!_.isEmpty(accounts)) {
            //         _.each(accounts, account => {
            //             availableValues.push(
            //                 formatSearchValues(
            //                     `${account.accountHolder} - ${account.accountNumber}`,
            //                     account.accountNumber,
            //                     'account'
            //                 )
            //             );
            //         });
            //     }

            //     if (!_.isEmpty(policies)) {
            //         _.each(policies, policy => {
            //             availableValues.push(
            //                 formatSearchValues(
            //                     `${policy.accountNumber} - ${policy.policyNumber}`,
            //                     policy.policyNumber,
            //                     'policy'
            //                 )
            //             );
            //         });
            //     }
            // }

            return availableValues;
        },
        [auth, formatSearchValues, translator]
    );
    
    const navigateToTWIAAgentsPage = useCallback(() => {
        const urlTWIA = 'https://www.twia.org/agents/';
        const urlTFPA = 'https://www.texasfairplan.org/agents';

        if (auth && auth.authUserData) {
            const { authUserData: { associationName_TWIA } } = auth;

            if (associationName_TWIA === 'twia') {
                // eslint-disable-next-line security/detect-non-literal-fs-filename
                window.open(urlTWIA, '_blank');
            }
            else if (associationName_TWIA === 'tfpa') {
                // eslint-disable-next-line security/detect-non-literal-fs-filename
                window.open(urlTFPA, '_blank');
            }
        }
    }, [auth]);

    const hyperLinkToNavigate = useCallback((url) => {
        // eslint-disable-next-line security/detect-non-literal-fs-filename
        window.open(url, '_blank');
    }, []);

    const floorPlansConfig = useMemo(
        () => [
            {
                scrollContent: false,
                showFooter: false,
                showSubHeader: !agentRegistration,
                routes,
                header: {
                    avatarChildren: avatarLinks,
                    avatarProps: {
                        // DE18191 - Display user info from PC not IdP
                        useAuthInfo: false, // set to false to use PC data
                        username: _.get(auth, 'authUserData.displayName'), 
                        title: _.get(auth, 'authUserData.displayName'),
                        subtitle: _.get(auth, 'authUserData.userName_EXT'),                        
                    },
                    className: agentRegistration ? 'registrationHeader' : 'appHeader',
                    logoSrc: getLogoSrc(),
                    onSearchValueChange,
                    // 2024-11-12 - Debra Frum - US26423 - PE - Search Accounts, Policies, Contacts - Solr Search
                    // Display tooltip for the Search field in the Header
                    renderCustomComponent: () => (
                        agentRegistration ? <span /> : <React.Fragment>
                            <div className="customComponentDiv">
                            <TooltipIcon
                                id="search-tooltip-icon"
                                className="searchTooltipIcon"
                                icon="gw-help"
                                text={translator(
                                    messages.searchTooltipMessage
                                )}
                                // TODO: hover doesn't work
                                trigger="hover focus"
                            />
                            <Link
                            className="helpLinkMargin"
                                onClick={() => navigateToTWIAAgentsPage()}>
                                Help
                            </Link>
                        </div>
                            {banner !== "" ? <div className="portalBannerContainer">
                                <div className="portalBannerContent">
                                    <i className="fa fa-exclamation-triangle bannerIcon" /> 
                                    <span>
                                        {htmlParser(banner)}
                                    </span>

                                </div>
                            </div> : <span/>} 
                        </React.Fragment>
                    ),
                    onLoadValues: handleLoadValues,
                    showAppSwitcher: false,
                    showNotifications: false,
                    searchFieldPlaceholder: messages.searchPlaceHolder,
                    searchOptionTypes: [
                        {
                            type: 'account',
                            icon: 'gw-account-box',
                            displayName: translator(messages.account),
                        },
                        {
                            type: 'policy',
                            icon: 'gw-policy',
                            displayName: translator(messages.policy),
                        },
                        {
                            type: '',
                            displayName: ' ',
                        },
                    ],
                }, 
                subHeader: {
                    renderCustomComponent: () => (
                        agentRegistration ? <span></span> : <Button
                            icon="mi-add"
                            type="action"
                            onClick={function goToNewQuote(){ return history.push('/new-quote-account-search')}}> 
                                {translator(messages.startNewQuote)} 
                        </Button>
                    )
                },
            },
        ],
        [
            auth,
            avatarLinks,
            getLogoSrc,
            handleLoadValues,
            onSearchValueChange,
            routes,
            translator,
            banner,
        ]
    );

    useEffect(() => {
        checkAdminiPermission();
        checkViewCommissionsAnalyticsPermission();
        checkViewBulkProducerChangePermission();
    }, [checkAdminiPermission, checkViewCommissionsAnalyticsPermission, checkViewBulkProducerChangePermission]);

    return (
        <AccurateBreakpointPropagation>
            <DependencyProvider
                value={{
                    LoadSaveService,
                    CustomQuoteService,
                    ClaimService: ENTGatewayClaimService,
                    ClaimDownloadService: ENTGatewayClaimDocumentService,
                    FNOLService: GatewayFNOLService,
                    AvailabilityService: GatewayAvailabilityService,
                    RenewalService: GatewayRenewalService,
                    DocumentService: GatewayDocumentService,
                    SpreadsheetService: GatewaySpreadsheetService,
                    EndorsementService: GatewayEndorsementService,
                    AccountService,
                    BillingService: GatewayBillingService,
                    UserService,
                    ContactService: ProducerInfoService,
                    quoteUnderWritingService: {
                        referToUnderwriter:
                            SubmissionService.referToUnderwriter,
                        withdrawJobByJobNumber:
                            JobService.withdrawJobByJobNumber,
                        approveUnderwritingIssue:
                            LoadSaveService.approveUnderwritingIssue,
                    },
                }}
            >
                <ViewModelServiceContext.Provider value={viewModelService}>
                    <ErrorBoundary onError={handleError}>
                        <SelectProducerContextProvider>
                            <Router
                                history={history}
                                basename="/producer-engage"
                                getUserConfirmation={(message, callback) =>
                                    routeConfirmationModal(
                                        message,
                                        callback,
                                        modalEmitter
                                    )
                                }
                            >
                                <AppFloorPlan
                                    componentMap={componentMap}
                                    floorPlans={floorPlansConfig}
                                />
                            </Router>
                        </SelectProducerContextProvider>
                    </ErrorBoundary>
                </ViewModelServiceContext.Provider>
            </DependencyProvider>
        </AccurateBreakpointPropagation>
    );
}


export default (withMaintenancePage({ appConfig, checkMaintenanceMode}))(
    (withAuthenticationProvider({
        onAuthDataCreation: getUserAuthData,
            unsecuredRoutes: [/.*\/new-agent.*/,/.*\/activationlink/,/.*\/fwUserSelfActivation/,/.*\/logout/],
        })(App))
)


